import { Form, InputNumber } from "antd";
import { LabeledField } from "../labeledField/labeledField";

export const MinPayField = ({
  form,
  disabled,
  isFormItem = true,
  extraLabel = null,
  style = {},
}) => {
  const formatter = (value) =>
    `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  const validateStartingFields = (fromValue, to) => {
    if (!form) return Promise.resolve();
    const toValue = form.getFieldValue(to);
    if (!fromValue && toValue) {
      return Promise.reject("Enter Min Pay!");
    }
    if (parseInt(fromValue) > parseInt(toValue)) {
      return Promise.reject("Value should be less than `Max Pay` field");
    }
    return Promise.resolve();
  };

  const renderField = () => (
    <InputNumber
      min={0}
      className="modalInput w-100"
      formatter={formatter}
      disabled={disabled}
      style={style}
    />
  );

  if (isFormItem) {
    return (
      <Form.Item
        label="Min Pay"
        name="minPay"
        rules={[
          { required: true, message: "Please enter min pay" },
          () => ({
            validator(_, value) {
              return validateStartingFields(value, "maxPay");
            },
          }),
        ]}
      >
        {renderField()}
      </Form.Item>
    );
  }

  return (
    <LabeledField label="Min Pay" required extra={extraLabel}>
      {renderField()}
    </LabeledField>
  );
};
